module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('mu-appbar', [_c('span', {
    staticClass: "topT"
  }, [_vm._v("非会员订单查询")]), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "keyboard_arrow_left",
      "color": "white"
    },
    on: {
      "click": _vm.goback
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_left",
      "color": "#27ba69"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.IsLoading),
      expression: "  IsLoading  "
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "1.2rem",
      "margin": "2.1rem auto 0 auto"
    },
    attrs: {
      "src": require("../../../../static/LoadingWhite.gif")
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }, [_vm._v("\n      登陆中...\n    ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.IsLoading),
      expression: "  !IsLoading  "
    }],
    staticClass: "bigpage"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "2vh"
    },
    attrs: {
      "align": "left"
    }
  }, [_c('mu-text-field', {
    staticStyle: {
      "margin-left": "-4%",
      "width": "103%"
    },
    attrs: {
      "hintText": "请输入手机号或邮箱",
      "type": "text",
      "icon": "smartphone",
      "fullWidth": ""
    },
    model: {
      value: (_vm.UserPhone),
      callback: function($$v) {
        _vm.UserPhone = $$v
      },
      expression: "UserPhone"
    }
  }), _vm._v(" "), _c('nobr', [_c('mu-text-field', {
    staticStyle: {
      "margin-left": "-4%",
      "width": "69%"
    },
    attrs: {
      "hintText": "请输入附加码",
      "type": "text",
      "icon": "vpn_key"
    },
    model: {
      value: (_vm.FJM1),
      callback: function($$v) {
        _vm.FJM1 = $$v
      },
      expression: "FJM1"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "30%",
      "margin-left": "2%",
      "float": "right",
      "margin-top": "-0.1rem"
    },
    attrs: {
      "src": _vm.TPFJM
    },
    on: {
      "click": this.getValidateCode
    }
  })], 1), _vm._v(" "), _c('nobr', [_c('mu-text-field', {
    staticClass: "txtValidate",
    staticStyle: {
      "margin-left": "-4%",
      "width": "69%",
      "z-index": "1"
    },
    attrs: {
      "hintText": "请输入动态密码",
      "type": "text",
      "icon": "verified_user"
    },
    model: {
      value: (_vm.YZM),
      callback: function($$v) {
        _vm.YZM = $$v
      },
      expression: "YZM"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveYZM == false),
      expression: "haveYZM == false"
    }],
    on: {
      "click": _vm.getYZM
    }
  }, [_c('input', {
    staticStyle: {
      "font-size": "0.32rem",
      "float": "right",
      "background-color": "#27ba69",
      "height": "0.7rem",
      "border": "none",
      "width": "30%",
      "color": "white"
    },
    attrs: {
      "type": "button",
      "value": "获取"
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveYZM == true),
      expression: "haveYZM == true"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.WaitTime),
      expression: "WaitTime"
    }],
    staticStyle: {
      "font-size": "0.32rem",
      "float": "right",
      "background-color": "#eeeeee",
      "height": "0.7rem",
      "border": "none",
      "width": "30%",
      "color": "#999"
    },
    attrs: {
      "type": "button"
    },
    domProps: {
      "value": (_vm.WaitTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.WaitTime = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "font-size": "0.3rem",
      "margin-top": "0.2rem"
    },
    style: ({
      width: '100%',
      height: '0.8rem'
    }),
    attrs: {
      "label": "查 询",
      "primary": ""
    },
    on: {
      "click": _vm.QueryOrderWithoutLogin
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "font-size": "0.3rem",
      "color": "#FF8F3B"
    },
    attrs: {
      "slot": "left",
      "to": "/user/Login"
    },
    slot: "left"
  }, [_vm._v("\n      已有账号？直接登录\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d787140!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/NonVerified/OtherUser.vue
// module id = 1480
// module chunks = 18